import MediaImage from './MediaImage';
import NpcPortrait from './NpcPortrait';
import StatusBar from './PlayStatusBar';

export function PlayBeingCard({ label, beingId, portrait = {}, loadRelationships, headingNote, vitals, attacking = false }) {
  return <article className={`play-card play2-card play-being-card play2-visible-being-card${vitals ? ' play2-party-member-card' : ''}${attacking ? ' play-combat-attacking' : ''}`}
    aria-label={attacking ? `${label}: attacking in combat` : undefined}>
    <h3>{label}{headingNote}</h3>
    <div className={`play2-card-media${vitals ? ' play2-card-media-with-vitals' : ''}`}>
      <div className="play-card-image-frame">
        {portrait.src ? <NpcPortrait src={portrait.src} label={label} beingId={beingId} loadRelationships={loadRelationships} />
          : <div className="play-card-placeholder play2-being-placeholder" aria-live="polite">{portrait.isGenerating ? 'Generating...' : portrait.isLoading ? 'Loading image...' : portrait.error ? 'Image unavailable' : 'No saved image'}</div>}
      </div>
      {vitals}
    </div>
  </article>;
}

export function PlayPlaceCard({ placeId, label, imageState = {}, showImage = false, onOpenMap }) {
  const placeholder = imageState.isLoading ? 'Loading image...' : imageState.error ? 'Image unavailable' : 'No saved image';
  return <article className="play-card play2-card play-place-card">
    <h2>{label}</h2>
    <div className="play2-card-media">
      {showImage ? <div className="play-card-image-frame">
        {imageState.src ? <NpcPortrait src={imageState.src} label={label} kind="image" />
          : <div className="play-card-placeholder" aria-live="polite">{placeholder}</div>}
      </div> : <button type="button" className="play-card-image-frame play2-place-map-button"
        onClick={() => onOpenMap(placeId)} disabled={!placeId}
        title={`Open top-down view for ${label}`} aria-label={`Open top-down view for ${label}`}>
        {imageState.src ? <MediaImage src={imageState.src} alt={label} />
          : <div className="play-card-placeholder" aria-live="polite">{placeholder}</div>}
      </button>}
    </div>
  </article>;
}

export function PlayPlayerCard({ label, portrait = {}, health, maxHealth, stamina, maxStamina, mana, maxMana, hasMana, onOpenSheet, advancementPending = false, attacking = false }) {
  const canOpenSheet = Boolean(onOpenSheet);
  return <article className={`play-card play2-card play-being-card play2-player-card ${canOpenSheet ? 'play-card-clickable' : ''}${advancementPending ? ' play-advancement-pending' : ''}${attacking ? ' play-combat-attacking' : ''}`}
    onClick={onOpenSheet} onKeyDown={canOpenSheet ? event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onOpenSheet(); }
    } : undefined} role={canOpenSheet ? 'button' : undefined} tabIndex={canOpenSheet ? 0 : undefined}
    title={canOpenSheet ? advancementPending ? 'Level earned — open your character sheet to allocate points' : 'Open character sheet' : undefined}
    aria-label={[advancementPending ? 'level earned, allocate points' : null, attacking ? 'attacking in combat' : null].filter(Boolean).length
      ? `${label}: ${[advancementPending ? 'level earned, allocate points' : null, attacking ? 'attacking in combat' : null].filter(Boolean).join('; ')}` : undefined}>
    <h3>{label}</h3>
    <div className="play2-card-media play2-card-media-with-vitals">
      <div className="play-card-image-frame">
        {portrait.src ? <MediaImage src={portrait.src} alt={label} />
          : <div className="play-card-placeholder" aria-live="polite">{portrait.error ? 'Portrait unavailable' : 'Loading...'}</div>}
      </div>
      <div className="play2-vital-rail">
        <StatusBar label="Health" value={health} max={maxHealth} className="play-health-bar" />
        <StatusBar label="Stamina" value={stamina} max={maxStamina} className="play-stamina-bar" />
        {hasMana && <StatusBar label="Mana" value={mana} max={maxMana} className="play-magic-bar" />}
      </div>
    </div>
  </article>;
}
